import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  icon: PropTypes.node,
  iconClassName: PropTypes.string,
  helperText: PropTypes.node,
};

const CardDesignerCardElementPlaceholder = ({
  icon,
  iconClassName,
  helperText,
  ...props
}) => {
  const iconClasses = classNames({
    'card-designer-card-element-placeholder-icon': true,
    [iconClassName]: !!iconClassName,
  });
  return (
    <div className="card-designer-card-element-placeholder" {...props}>
      {icon && <span className={iconClasses}>{icon}</span>}
      {helperText && (
        <span className="card-designer-card-element-placeholder-helper-text">
          {helperText}
        </span>
      )}
    </div>
  );
};

CardDesignerCardElementPlaceholder.propTypes = propTypes;

export default CardDesignerCardElementPlaceholder;
